import { create } from 'zustand';

interface AppState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (v: boolean) => void;

  commandPaletteOpen: boolean;
  setCommandPaletteOpen: (v: boolean) => void;

  notificationOpen: boolean;
  setNotificationOpen: (v: boolean) => void;

  profileMenuOpen: boolean;
  setProfileMenuOpen: (v: boolean) => void;

  density: 'compact' | 'comfortable';
  setDensity: (d: 'compact' | 'comfortable') => void;

  accentColor: string;
  setAccentColor: (c: string) => void;

  currentTenant: string;
  setCurrentTenant: (t: string) => void;

  wsConnected: boolean;
  setWsConnected: (v: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  sidebarCollapsed: false,
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setSidebarCollapsed: (v) => set({ sidebarCollapsed: v }),

  commandPaletteOpen: false,
  setCommandPaletteOpen: (v) => set({ commandPaletteOpen: v }),

  notificationOpen: false,
  setNotificationOpen: (v) => set({ notificationOpen: v }),

  profileMenuOpen: false,
  setProfileMenuOpen: (v) => set({ profileMenuOpen: v }),

  density: 'comfortable',
  setDensity: (d) => set({ density: d }),

  accentColor: '#3b82f6',
  setAccentColor: (c) => {
    document.documentElement.style.setProperty('--accent', c);
    set({ accentColor: c });
  },

  currentTenant: 'default',
  setCurrentTenant: (t) => set({ currentTenant: t }),

  wsConnected: false,
  setWsConnected: (v) => set({ wsConnected: v }),
}));
